import { Button } from "@dm-4dev/ui";
import { useMainMenu } from "@route/layout/lib/use-menu";
import { Link } from "react-router-dom";
import { APP_ROUTES } from "../../router";

export const DesktopSidebar = () => {
  const mainMenu = useMainMenu();

  return (
    <div className="w-64 bg-white border-r border-slate-200 flex-shrink-0 hidden md:flex flex-col z-10 shadow-sm h-full overflow-y-auto overflow-x-hidden">
      <div className="flex justify-center items-center py-6">
        <Link to={APP_ROUTES.HOME}>
          <img src="/comu-app-logo.png" alt="logo" className="h-16 w-auto" />
        </Link>
      </div>
      <div className="px-2 flex flex-col gap-2 mt-2 pb-6">
        {mainMenu.map((item) => (
          <Button
            key={item.label}
            {...item.buttonProps}
            onClick={(e) => {
              if (item?.buttonProps?.onClick) item.buttonProps.onClick(e);
            }}
            align="left"
          >
            {item.label}
          </Button>
        ))}
      </div>
    </div>
  );
};
